import { render } from "./NotFound.vue?vue&type=template&id=50c6f348&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=50c6f348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c6f348"]])

export default __exports__